import { makeStyles, shorthands } from '@fluentui/react-components';

export const useExampleImageListStyles = makeStyles({
  exampleImageList: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    ...shorthands.overflow('hidden'),
    ...shorthands.gap('6px'),
  },
});

export const useExampleImageCellStyles = makeStyles({
  exampleImageCell: {
    width: 'calc(50% - 3px)', // 3px is half the gap between cells
    aspectRatio: '1 / 1',
    ...shorthands.borderRadius('6px'),
    ...shorthands.overflow('hidden'),
    position: 'relative',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },

    '&:focus .example-image-list-cell-overlay, &:hover .example-image-list-cell-overlay': {
      visibility: 'visible',
      animationDuration: '0.2s, 0.5s',
      animationTimingFunction: 'ease-in-out, linear',
      animationName: [{
        from: { transform: 'translateY(100%)' },
        to: { transform: 'translateY(0%)' },
      }, {
        from: { opacity: 0 },
        to: { opacity: 1 },
      }],
    },

    '& .example-image-list-cell-overlay': {
      position: 'absolute',
      width: '100%',
      height: '100%',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      display: 'flex',
      flexDirection: 'column',
      visibility: 'hidden',
      opacity: 0.8,

      '& .overlay-gradient': {
        ...shorthands.flex(1),
        alignSelf: 'stretch',
        backgroundImage: 'linear-gradient(180deg, rgba(49, 34, 34, 0.20) 44.79%, rgba(49, 34, 34, 0.90) 76.04%, #312222 100%);',
      },

      '& .overlay-solid': {
        backgroundColor: '#312222',
        height: '25%',
        flexShrink: 0,
        alignSelf: 'stretch',
      },

      '& .example-prompt-template': {
        width: '100%',
        height: '100%',
        minWidth: '100px',
        minHeight: '100px',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        ...shorthands.padding('8px'),

        color: '#FFF',
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 600,
        lineHeight: 'normal',
        '& .multi-line-hidden-text': {
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          ...shorthands.padding('8px'),
        },
      },
    },
  },
});

